import Poster1 from "./assets/poster1.png";
import Poster2 from "./assets/poster2.png";
import Poster3 from "./assets/poster3.png";
import Poster4 from "./assets/poster4.png";
import Poster5 from "./assets/poster5.png";
import Poster6 from "./assets/poster6.png";
import Poster7 from "./assets/poster7.png";
import Poster8 from "./assets/poster8.png";
import Poster9 from "./assets/poster9.png";
import Poster10 from "./assets/poster10.png";
import Poster11 from "./assets/poster11.png";
import Poster12 from "./assets/poster12.png";
import Poster13 from "./assets/poster13.png";
import Poster14 from "./assets/poster14.png";

export const listOfPosters = [
  {
    img: Poster1,
    title: "פוקימון",
    description: "הצטרפו לאש, פיקאצ'ו וחברים במסעו להפוך לפוקימון מאסטר!",
    key: "poster1",
  },
  {
    img: Poster2,
    title: "גאליס",
    description: "קיץ ראשון לג'ונתן, גני וליעם ב'גאליס' - המחנה הכי מטורף!",
    key: "poster2",
  },
  { img: Poster3, title: "ארתור", description: "סדרה העוקבת אחרי חיו של ארתור, משפחתו וחבריו הטובים", key: "poster3" },
  {
    img: Poster4,
    title: "או בוי",
    description: "סדרה מוזיקלית סוחפת על הלהקה הכי מצליחה בישראל \"Oboy\"",
    key: "poster4",
  },
  {
    img: Poster5,
    title: "אליפים",
    description: "הכירו את הפנימייה החקלאית \"גנות\". ובואו לגלות מי הם האליפים",
    key: "poster5",
  },
  {
    img: Poster6,
    title: "אלישע",
    description: "אלישע (יובל סמו) הוא בטלן בן 40 עם דירת חדר וחצי ושקל וחצי בכיס",
    key: "poster6",
  },
  {
    img: Poster7,
    title: "תעשה לי סאב",
    description: "טום באום רוצה להיות כוכב רשת ומצטרף לג'וי ריגר וקווין רובין",
    key: "poster7",
  },
  {
    img: Poster8,
    title: "אינאזומה 11",
    description: "סדרת אנימה יפנית על מאנגה מבוססת על משחקים מצליחים",
    key: "poster8",
  },
  { img: Poster9, title: "החולמים", description: "סדרה שעוקבת אחרי ילדי בית האומנה \"המלונ\"ה\"", key: "poster9" },
  { img: Poster10, title: "השמיניה", description: "סדרה על 8 תלמידים בכיתה מיוחדת בתיכון במרכז הארץ", key: "poster10" },
  { img: Poster11, title: "הפיג'מות", description: "הכירו את הלהקה הנתניינית והאנונימית - הפיג'מות!", key: "poster11" },
  {
    img: Poster12,
    title: "קרי בייבז",
    description: "גלו את כוחה של חברות, הזדהות רגשית ועבודת צוות עם קריי בייביז!",
    key: "poster12",
  },
  {
    img: Poster13,
    title: "סאני באניז",
    description: "הצטרפו אל חברות סאני באניז הנבונים, פזיזים, חכמים ויצירתיים!",
    key: "poster13",
  },
  {
    img: Poster14,
    title: "יצירה בכל הצבעים",
    description: "סתיו בכל הצבעים בתוכנית יצירה נוצצת ומרגשת!",
    key: "poster14",
  },
];



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/config.js